class AfterSales {
  constructor() {
    this.domain = null;
    this.path = [];
    this.docTreeRaw = [];
    this.docTreeRawDate = null;
    this.favorites = [];
    this.searchProduct = {
      model: null,
    }
    this.searchDocument = { 
      model: null, 
      category: null,
      title: null,
      language: null
    }
    this.searchSerial = {
      productCode: null,
      serialNumber: null
    },
    this.sparePartsDocs = null;
    this.cart = [];
  }
}

// initial state
const state = () => (new AfterSales());

// getters
const getters = {
  path: state => {
    return state.path
  },
  domain: state => {
    return state.domain
  },
  docTreeRaw: state => {
    return state.docTreeRaw
  },
  docTreeRawDate: state => {
    return state.docTreeRawDate
  },
  favorites: state => {
    return state.favorites
  },
  searchProduct: state => {
    return state.searchProduct
  },
  searchSerial: state => {
    return state.searchSerial
  },
  searchDocument: state => {
    return state.searchDocument
  },
  sparePartsDocs: state => {
    return state.sparePartsDocs
  },
  cart: state => {
    return state.cart
  }

}

// actions
const actions = {

}

// mutations
const mutations = {
  path: function(state , payload) {
    state.path = payload
  },
  pathPop: function(state) {
    state.path.pop();
  },
  domain: function(state , payload) {
    state.domain = payload
  },
  docTreeRaw: function(state , payload) {
    state.docTreeRaw = payload
    state.docTreeRawDate = new Date()
  },
  favorites: function(state , payload) {
    state.favorites = payload
  },
  searchProductModel: function(state , payload) {
    state.searchProduct = payload
  },
  searchDocument: function(state , payload) {
    state.searchDocument = payload
  },
  searchSerial: function(state , payload) {
    state.searchSerial = payload
  },
  sparePartsDocs: function(state , payload) {
    state.sparePartsDocs = payload
  },
  cart: function(state , payload) {
    state.cart = payload
  },
  reset: function(state) {
    Object.assign(state, new AfterSales());
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
